import React from 'react';
import './Newsletter.css';

export default function Newsletter() {
  return (
    <main id='newsletter-main'>
      <h2>
        Sign up for my newsletter!
      </h2>
      <button id='newsletter-button'>
        <a
          href='https://hnfisher.eo.page/cc1jk'
        >
          Get a FREE first chapter!
        </a>
      </button>
    </main>
  )
}
